import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Suspense } from 'react';
import { RouterProvider } from 'react-router';
import { Skeleton, Toaster, UILinkProvider } from '@athlete/ui';
import { isApiError } from '@/api';
import { onSessionEnded } from '@/api/http/session';
import { ALL_MODULES } from '@/app/registry';
import { RouterLink } from '@/platform/link';
import { ModulesProvider } from '@/platform/moduleContext';
import { router } from './router';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: false,
      // Permission errors and missing records are answers, not transient failures.
      retry: (count, error) => !(isApiError(error) && [400, 403, 404, 409].includes(error.status)) && count < 2,
    },
  },
});

// The service says the session is over (idle too long, or the account was switched off): forget what was fetched and go to sign-in.
onSessionEnded(() => {
  queryClient.clear();
  void router.navigate('/login', { replace: true });
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <UILinkProvider link={RouterLink}>
        <ModulesProvider modules={ALL_MODULES}>
          <Suspense fallback={<div className="mx-auto w-full max-w-[1480px] p-6 lg:p-8"><Skeleton className="h-40 w-full" /></div>}>
            <RouterProvider router={router} />
          </Suspense>
        </ModulesProvider>
        <Toaster />
      </UILinkProvider>
    </QueryClientProvider>
  );
}
